import { getGlobals } from '@ebay/presence-ui/lib/global-variables';
import storeEvent from '@ebay/presence-ui/lib/store-event';

export default class {
    onCreate(input) {
        this.page = input.page;
    }
    onMount() {
        this.root = this.getEl('str-shop-header');
        this.shopTabIndexes = getGlobals().shopTabIndexes;
        if (this.root) {
            this.shopTabIndexes = getGlobals().shopTabIndexes;
            storeEvent.tabHasChanged.listen(data => {
                if (this.shopTabIndexes?.indexOf(data.hash) === -1) {
                    this.root.classList.add('hide');
                } else {
                    this.root.classList.remove('hide');
                }
            });
        }
    }
}
